import React, {useCallback, useState} from 'react';
import {ReadonlyCanvas} from '../ReadonlyCanvas';
// import {t4} from './DrawingDataType';
import TitleImg from '../../images/confirm__title.png';
import TitleImgSp from '../../images/sp/confirm__title.png';
import './ConfirmPage.scss';
import frameImg from "../../images/drawing__frame.png";
import BackButtonImg from '../../images/back-button.png';
import BackButtonHoverImg from '../../images/back-button--hover.png';
import SaveButtonImg from '../../images/save-button.png';
import SavingButtonImg from '../../images/saving-button.png';
import SaveButtonHoverImg from '../../images/save-button--hover.png';
import {Store} from "../../models/Store";

type P = {
    onDone: () => void;
    onBack: () => void;
};

export const ConfirmPage = (props: P) => {

    const [isSaving, setSaving] = useState(true);


    // event handler

    const onFinishButtonClick = async () => {
        if (!isSaving) return;

        setSaving(false);

        // モデルに保存
        // Store.database_endDraw();

        // 完了フラグをFirebaseに書き込み
        await Store.smileRegister.updateDone();

        // コールバック
        props.onDone();
    };

    const onBackButtonClick = useCallback(() => {
        props.onBack();
    }, [props]);

    // render

    return (
        <div className='confirm'>

            <h1><img src={(Store.device === 'mobile') ? TitleImgSp : TitleImg} alt='' width={742} height={80}/></h1>


            <div className="confirm__position-fixer-mobile">
                <div className="confirm__position-fixer-inner-mobile">

                    <div className="confirm__canvas-button-container">

                        <div className="confirm__canvas-outer">

                            <div className='confirm__canvas-container'>
                                <img src={frameImg} alt=""/>
                                <ReadonlyCanvas></ReadonlyCanvas>
                            </div>

                        </div>

                        <div className="confirm__button-outer">


                            <div className="confirm__button-container">
                                {
                                    isSaving
                                        ? <div>
                                            <img width={288} height={101} className='confirm__back-button'
                                                 src={BackButtonImg}
                                                 onMouseOver={e => e.currentTarget.src = BackButtonHoverImg}
                                                 onMouseOut={e => e.currentTarget.src = BackButtonImg}
                                                 alt=""
                                                 onClick={onBackButtonClick}/>
                                            < input width={288} height={101} className='confirm__yes-button' type="image"
                                                    src={SaveButtonImg}
                                                    onMouseOver={e => e.currentTarget.src = SaveButtonHoverImg}
                                                    onMouseOut={e => e.currentTarget.src = SaveButtonImg}
                                                    onClick={onFinishButtonClick} alt=""/>
                                        </div>
                                        : <div><img width={288} height={101} src={SavingButtonImg} alt=""/></div>
                                }
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};